import React from 'react';
import { View as BackboneView } from 'backbone';
import PropTypes from 'prop-types';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { BackboneViewWrapper } from '@bingads-webui-react/backbone-view-wrapper';

export const PanelBackboneWrapper = ({
  panelProps, View, viewOptions, eventsToActions,
}) => (
  <Panel {...panelProps}>
    <BackboneViewWrapper
      View={View}
      options={viewOptions}
      eventsToActions={eventsToActions}
    />
  </Panel>);

PanelBackboneWrapper.propTypes = {
  panelProps: PropTypes.shape({}),
  View: PropTypes.oneOfType([BackboneView]).isRequired,
  viewOptions: PropTypes.shape({}),
  eventsToActions: PropTypes.arrayOf(PropTypes.shape({
    event: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
  })),
};

PanelBackboneWrapper.defaultProps = {
  panelProps: {},
  viewOptions: {},
  eventsToActions: [],
};
